/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ChangeEmailRequest } from '../model';
/**
 * AdminUserControllerApi - axios parameter creator
 * @export
 */
export const AdminUserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} userId 
         * @param {ChangeEmailRequest} changeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserEmail: async (userId: number, changeEmailRequest: ChangeEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('changeUserEmail', 'userId', userId)
            // verify required parameter 'changeEmailRequest' is not null or undefined
            assertParamExists('changeUserEmail', 'changeEmailRequest', changeEmailRequest)
            const localVarPath = `/api/admin/user/email-change/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserControllerApi - functional programming interface
 * @export
 */
export const AdminUserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} userId 
         * @param {ChangeEmailRequest} changeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserEmail(userId: number, changeEmailRequest: ChangeEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserEmail(userId, changeEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUserControllerApi - factory interface
 * @export
 */
export const AdminUserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} userId 
         * @param {ChangeEmailRequest} changeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserEmail(userId: number, changeEmailRequest: ChangeEmailRequest, options?: any): Promise<void> {
            return localVarFp.changeUserEmail(userId, changeEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserControllerApi - object-oriented interface
 * @export
 * @class AdminUserControllerApi
 * @extends {BaseAPI}
 */
export class AdminUserControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} userId 
     * @param {ChangeEmailRequest} changeEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserControllerApi
     */
    public changeUserEmail(userId: number, changeEmailRequest: ChangeEmailRequest, options?: AxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).changeUserEmail(userId, changeEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
